module.exports = __webpack_public_path__ + "img/Feature.c80a0d7e.png";